import React from 'react';
import { Row, Col, Card } from 'react-bootstrap';

const icons = {
    folder: (color) => (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path>
        </svg>
    ),
    checkCircle: (color) => (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
            <polyline points="22 4 12 14.01 9 11.01"></polyline>
        </svg>
    ),
    mail: (color) => (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
            <polyline points="22,6 12,13 2,6"></polyline>
        </svg>
    ),
    thumbsUp: (color) => (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3zM7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3"></path>
        </svg>
    ),
    thumbsDown: (color) => (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M10 15v4a3 3 0 0 0 3 3l4-9V2H5.72a2 2 0 0 0-2 1.7l-1.38 9a2 2 0 0 0 2 2.3zm7-13h3a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2h-3"></path>
        </svg>
    ),
    logOut: (color) => (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
            <polyline points="16 17 21 12 16 7"></polyline>
            <line x1="21" y1="12" x2="9" y2="12"></line>
        </svg>
    ),
    xCircle: (color) => (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="15" y1="9" x2="9" y2="15"></line>
            <line x1="9" y1="9" x2="15" y2="15"></line>
        </svg>
    ),
};

const CARD_CONFIG = [
    { key: 'opportunities', label: 'Opportunities', icon: 'folder', color: '#4F5BD5', bg: '#EEF1FF' },
    { key: 'renewalsDone', label: 'Renewals Done', icon: 'checkCircle', color: '#28A745', bg: '#E9F9EE' },
    { key: 'renewalsIntimated', label: 'Renewals Intimated', icon: 'mail', color: '#7B61FF', bg: '#F1EEFF' },
    { key: 'proposalsSent', label: 'Proposals Sent', icon: 'mail', color: '#4F5BD5', bg: '#EEF1FF' },
    { key: 'proposalsAccepted', label: 'Proposals Accepted', icon: 'thumbsUp', color: '#28A745', bg: '#E9F9EE' },
    { key: 'proposalsRejected', label: 'Proposals Rejected', icon: 'thumbsDown', color: '#DC3545', bg: '#FDECEC' },
    { key: 'moveOuts', label: 'Move Outs', icon: 'logOut', color: '#6C757D', bg: '#F1F2F3' },
    { key: 'discontinued', label: 'Discontinued', icon: 'xCircle', color: '#FD7E14', bg: '#FFF1E4' },
];

/**
 * PMSRenewalsStatsCards
 * Pure display component — pass in a `stats` object keyed by card key.
 * No click/filter behavior; purely renders whatever numbers it's given.
 *
 * @param {object} stats - e.g. { opportunities: 310, renewalsDone: 0, renewalsIntimated: 86, ... }
 */
const PMSRenewalsStatsCards = ({ stats = {} }) => {
    return (
        <Row className="g-3 mb-4">
            {CARD_CONFIG.map(card => (
                <Col key={card.key} xs={6} sm={4} md={3} lg={true}>
                    <Card className="h-100" style={{ border: '1px solid #E9ECEF', borderRadius: 10 }}>
                        <Card.Body className="d-flex align-items-center gap-3 py-3 px-3">
                            <div
                                className="d-flex align-items-center justify-content-center rounded-circle flex-shrink-0"
                                style={{ width: 40, height: 40, background: card.bg }}
                            >
                                {icons[card.icon](card.color)}
                            </div>
                            <div>
                                <div className="fw-bold" style={{ fontSize: '1.15rem', lineHeight: 1.1 }}>
                                    {stats[card.key] ?? 0}
                                </div>
                                <div className="text-muted" style={{ fontSize: '0.78rem' }}>
                                    {card.label}
                                </div>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
            ))}
        </Row>
    );
};

export default PMSRenewalsStatsCards;